import styled, { css } from "styled-components";
import { COLORS, fontMixins } from "../../../styles";

export const PeriodContainer = styled.div`
	display: flex;
	justify-content: center;
	margin: 26px 0 0;

	div {
		&:last-child {
			margin-left: 25px;
		}
	}
`;

interface PeriodItemContainerProps {
	isActive: boolean;
}

export const PeriodItemContainer = styled.div<PeriodItemContainerProps>`
	display: flex;
	${fontMixins(14, 500)};
	padding: 8px 11px;
	color: #000;
	border-width: 1px 0 1px 1px;
	border-color: #000;
	border-style: solid;
	cursor: pointer;

	&:first-child {
		border-radius: 4px 0 0 4px;
	}

	&:nth-child(2) {
		border-right-width: 1px;
		border-radius: 0 4px 4px 0;
	}

	${(props) =>
		props.isActive &&
		css`
			background: #000;
			color: #fff;
		`}
`;

export const ArrowTitle = styled.div`
	position: relative;
	top: 2px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: ${COLORS.Gold};
	color: ${COLORS.White};
	${fontMixins(12, 600)};
	padding-inline: 8px;
	margin-left: 18px;
	height: 28px;

	&:before {
		content: "";
		position: absolute;
		left: -10px;
		width: 0;
		height: 0;
		border-top: 14px solid transparent;
		border-right: 10px solid ${COLORS.Gold};
		border-bottom: 14px solid transparent;
	}
`;
